module.exports = __webpack_public_path__ + "static/media/podzielnia.8a9284f6.png";